import { SmilePlusIcon } from "lucide-react";

import { Button } from "@ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@ui/dropdown-menu";

import { SadieSimulatorTapback } from "@/types";

// The tapbacks a worker's phone can send, the way it draws them.
const TAPBACKS: { reaction: SadieSimulatorTapback; emoji: string }[] = [
  { reaction: "love", emoji: "❤️" },
  { reaction: "like", emoji: "👍" },
  { reaction: "dislike", emoji: "👎" },
  { reaction: "laugh", emoji: "😂" },
  { reaction: "emphasize", emoji: "‼️" },
  { reaction: "question", emoji: "❓" },
];

// Shows on hover beside one of Sadie's texts, for tapping back on it as the
// tester.
export const SadieSimulatorTapbackMenu = ({
  onTapback,
}: {
  onTapback: (reaction: SadieSimulatorTapback) => void;
}) => (
  <DropdownMenu>
    <DropdownMenuTrigger asChild>
      <Button
        aria-label="Tap back"
        className="h-7 w-7 shrink-0 text-slate-400 opacity-0 focus-visible:opacity-100 group-hover:opacity-100 data-[state=open]:opacity-100 [@media(hover:none)]:opacity-100"
        size="icon"
        variant="ghost"
      >
        <SmilePlusIcon className="h-4 w-4" />
      </Button>
    </DropdownMenuTrigger>
    <DropdownMenuContent align="end" className="flex min-w-0 gap-1 p-1">
      {TAPBACKS.map(({ reaction, emoji }) => (
        <DropdownMenuItem
          className="cursor-pointer px-2 text-lg"
          key={reaction}
          onSelect={() => {
            onTapback(reaction);
          }}
        >
          {emoji}
        </DropdownMenuItem>
      ))}
    </DropdownMenuContent>
  </DropdownMenu>
);
